import { AppState } from '../AppTypes';

export const _anyFlagEnabled = (state: AppState) => {
  return (flags: string[]): boolean => {
    if (import.meta.env.DEV) {
      return flags.some(flag => state.flags.includes(flag));
    }
    return flags.some(flag => state.ldClient.variation(flag, false) === true);
  };
};
